import {useSelector} from 'react-redux'
import {poseHeight} from './util'

const HipIndicators = ({keypoints,scale})=>{
	const leftWrist = keypoints[9]
	const rightWrist = keypoints[10]
	const leftHip = keypoints[11]
	const rightHip = keypoints[12]
	const height = poseHeight(keypoints)
	const w = 0.12*height*scale
	const h = 0.2*height*scale

	const leftWristOutsideBox = (
		//outside of x bounds
		leftWrist.x*scale <= leftHip.x*scale-w-0.03*height*scale ||
		leftWrist.x*scale >= leftHip.x*scale-0.03*height*scale ||
		//outside of y bounds
		leftWrist.y*scale <= leftHip.y*scale-h ||
		leftWrist.y*scale >= leftHip.y*scale
	)

	const rightWristOutsideBox = (
		//outside of x bounds
		rightWrist.x*scale <= (rightHip.x)*scale+0.03*height*scale ||
		rightWrist.x*scale >= rightHip.x*scale+w+0.03*height*scale ||
		//outside of y bounds
		rightWrist.y*scale <= rightHip.y*scale-h ||
		rightWrist.y*scale >= rightHip.y*scale
	)
	
	return (
		<>
			<rect
				stroke-width="2"
				stroke={leftWristOutsideBox?'red':'green'}
				fill="none"
				x={leftHip.x*scale-w-0.03*height*scale}
				y={leftHip.y*scale-h}
				width={w}
				height={h}
			/>
			<rect
				stroke-width="2"
				stroke={rightWristOutsideBox?'red':'green'}
				fill="none"
				x={(rightHip.x)*scale+0.03*height*scale}
				y={(rightHip.y)*scale-h}
				width={w}
				height={0.2*height*scale}
			/>
		</>
	)
}

const Indicators = ({threshold,scale})=>{
	const poses = useSelector(state=>state.ai.poses)
	return (
		poses.map(
			p => (
				<>
					<HipIndicators 
						keypoints={p.keypoints} 
						scale={scale}
					/>
				</>
			)
		)//end poses map
	)
}

export default Indicators